import { useSyncExternalStore } from 'react';
import { useOffice } from '@components/OfficeLoader';

import { isInIframe } from './helpers';

const emptySubscribe = () => () => {};

// In embed contexts (PowerPoint add-in / iframe) the HeroUI modal — which
// portals to document.body and relies on framer-motion — renders poorly, so we
// swap in the lightweight simple-modal instead.
//
// The iframe check must resolve synchronously on the very first render: modal
// sub-components (ModalContent/Header/Body/Footer) only mount when the modal
// opens, long after the parent Modal has settled to the embed branch. If they
// briefly read `false` they render the HeroUI parts without a HeroUI <Modal>
// ancestor and crash with "useModalContext: context is undefined". Using
// useSyncExternalStore keeps the server snapshot `false` (no hydration
// mismatch) while giving every client render — including late mounts — the real
// value immediately.
const useIsEmbed = (): boolean => {
  const { isPowerpoint } = useOffice();
  const inIframe = useSyncExternalStore(
    emptySubscribe,
    () => isInIframe(),
    () => false,
  );

  return Boolean(isPowerpoint) || inIframe;
};

export default useIsEmbed;
